<template>
  <app-layout>
    <template #header>
      <div class="flex flex-row justify-between items-center">
        <h2 class="font-bold text-xl text-gray-800 leading-tight">
          <em class="fas fa-credit-card"></em> Cartão
        </h2>
        <balance :short="true" />
      </div>
    </template>
    <div class="py-12 pt-10 pb-6">
      <flash :timeout="5000" />
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 pt-10">
        <div class="flex justify-between mb-5">
          <span class="text-xl font-semibold text-black text-opacity-70"
            >Meus cartões</span
          >
          <button-confirmation @click.native="showReuqests">
            Solicitações
          </button-confirmation>
        </div>

        <cards-carrosel
          :cards="cards.list"
          :selectedCard="selectedCard"
          @active-card="
            selectedCard = $event.selectedCard;
            activeCard = $event.activeCard;
          "
        />
        <div class="flex items-center gap-10 px-6 py-4">
          <span>Opções</span>

          <div class="flex gap-2">
            <modal-password
              v-if="!cards.list[selectedCard].is_virtual"
              :class="verifyStatus.bg"
              :card="cards.list[selectedCard]"
              :customer="customer"
              :update="true"
              :isValidNumber="verifyStatus.isClick"
            />

            <!-- BOTÕES DE AÇÕES -->
            <button
              v-if="cards.list[selectedCard].status === 'locked'"
              class="py-2 px-5 border rounded bg-white border-gray-400 text-xs text-black text-opacity-70 uppercase"
              @click="openChangeStatusModal('unblock', cards.list[selectedCard])"
            >
              <em class="fas fa-lock-open"></em>
              Desbloquear cartão
            </button>

            <button
              v-else
              class="py-2 px-5 border rounded bg-white border-gray-400 text-xs text-black text-opacity-70 uppercase"
              :class="verifyStatus.bg"
              @click="
                verifyStatus.isClick ? openChangeStatusModal('block', cards.list[selectedCard]) : null
              "
            >
              <em class="fas fa-lock"></em>
              Bloquear Cartão
            </button>

            <button
              v-if="!cards.list[selectedCard].is_virtual"
              class="py-2 px-5 border rounded bg-white border-gray-400 text-xs text-black text-opacity-70 uppercase"
              :class="verifyStatus.bg"
              @click="
                verifyStatus.isClick
                  ? openChangeStatusModal('report_theft_or_loss', cards.list[selectedCard])
                  : null
              "
            >
              <em class="fas fa-exclamation-circle" />
              Reportar perda ou roubo
            </button>

            <button
              v-else
              class="py-2 px-5 border rounded bg-white border-gray-400 text-xs text-black text-opacity-70 uppercase"
              :class="{
                'opacity-50 cursor-not-allowed':
                  cards.list[selectedCard].status === 'locked' ||
                  cards.list[selectedCard].status === 'canceled',
              }"
              @click="
                cards.list[selectedCard].status === 'locked' ||
                cards.list[selectedCard].status === 'canceled'
                  ? null
                  : openRemoveCardModal(cards.list[selectedCard])
              "
            >
              <em class="fas fa-times" />
              Remover cartão
            </button>

            <button
              v-if="!cards.list[selectedCard].is_virtual"
              class="py-2 px-5 border rounded bg-white border-gray-400 text-xs text-black text-opacity-70 uppercase"
              :class="verifyStatus.bg"
              @click="
                verifyStatus.isClick
                  ? openChangeCancel('cancel', cards.list[selectedCard])
                  : null
              "
            >
              <em class="fas fa-ban" />
              Cancelar cartão
            </button>
            <button
              v-if="
                !cards.list[selectedCard].is_virtual &&
                cards.list[selectedCard].status !== 'theft_or_loss'
              "
              class="py-2 px-5 border rounded bg-white border-gray-400 text-xs text-black text-opacity-70 uppercase"
              :class="verifyVirtualActive.bg"
              @click="
                verifyVirtualActive.isClick
                  ? showModalCardVirtual(cards.list[selectedCard].uuid)
                  : null
              "
            >
              <em class="fas fa-credit-card"></em>
              Solicitar cartão virtual
            </button>

            <button
              v-else-if="
                !cards.list[selectedCard].is_virtual &&
                cards.list[selectedCard].status === 'theft_or_loss'
              "
              class="py-2 px-5 border rounded bg-white border-gray-400 text-xs text-black text-opacity-70 uppercase"
              :class="{
                'opacity-50 cursor-not-allowed':
                  verifyRequestCard.bg
              }"
              @click="
                verifyRequestCard.isClick
                  ? showModalRequestCard(cards.list[selectedCard])
                  : null
              "
            >
              <em class="fas fa-credit-card" />
              Solicitar novo cartão
            </button>
          </div>
        </div>
        <div class="bg-white shadow-xl sm:rounded-lg px-6 py-4">
          <div class="flex items-center justify-between mb-6">
            <div>
              <span class="font-bold text-xl text-black opacity-70">
                Extrato
              </span>
              <span class="text-base text-black text-opacity-60 m-2">
                Cartão ****
                {{
                  ["active", "theft_or_loss", "canceled"].includes(cards.list[selectedCard].status)
                    ? cards.list[selectedCard].last_4_digits
                    : "****"
                }}
              </span>
            </div>
            <div>
              <date-filter
                :buttons="buttonsDateFilter"
                :dateTimer="false"
                :showIconDate="false"
                class="mb-5"
              />
            </div>
          </div>
          <div>
            <inertia-table
              :tableClasses="'text-xs font-normal text-black text-opacity-60'"
              :data="transactions ? transactions : { list: [] }"
              :params="params"
              :columns="columns"
              :enable-search="false"
              :enableExport="false"
              :hasIcon="false"
              id="id"
            >
              <template slot-scope="{ item }" slot="datePuchase">
                <span
                  v-if="item.created"
                  class="text-sm text-black text-opacity-70"
                >
                  {{ item.created | smallDateTime }}
                </span>
                <span v-else class="text-sm text-gray-400">
                  --/--/---- --:--
                </span>
              </template>
              <template slot-scope="{ item }" slot="description">
                <span
                  v-if="item.description"
                  class="text-xs text-black text-opacity-70 whitespace-nowrap"
                  v-html="item.description_formatted"
                ></span>
                <span v-else class="text-sm text-black text-opacity-70"
                  >--</span
                >
              </template>
              <template slot-scope="{ item }" slot="origin">
                <span
                  v-if="item.description"
                  class="text-sm text-black text-opacity-70"
                  >{{ item.description | capitalizeName }}</span
                >
                <span v-else class="text-sm text-black text-opacity-70"
                  >--</span
                >
              </template>
              <template slot-scope="{ item }" slot="valuePurchase">
                <span class="text-sm text-red-400 font-bold whitespace-nowrap"
                  >-R$ {{ item.amount || 0 | currency }}</span
                >
              </template>
              <template slot-scope="{ item }" slot="balance">
                <span
                  class="text-sm text-black text-opacity-70 whitespace-nowrap"
                  >R$ {{ item.balance || 0 | currency }}</span
                >
              </template>
            </inertia-table>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL BLOQUEIO E DESBLOQUEIO DO CARTÃO -->
    <jet-confirmation-modal
      v-if="changeStatusModal"
      :show="changeStatusModal"
      @close="changeStatusModal = false"
      :scroll="false"
      :noBgFooter="true"
      :maxWidth="'2xl'"
    >
      <template #title>
        <div class="flex justify-center">
          <span class=" text-center text-black text-opacity-70 font-bold text-xl">
            {{ titleModalRequests }}
          </span>
        </div>
        <jet-section-border />
      </template>

      <template #content>
        <div class="flex flex-col">
          <div
            v-if="
              cards.list[selectedCard].status !== 'locked' &&
              changeStatusForm.status !== 'thief_or_loss'
            "
          >
            <div class="flex items justify-center mb-4">
              <img
                alt="Logo"
                class="mt-2 mr-4"
                src="images/blockCard.svg"
                width="200"
              />
            </div>
            <p class="text-base text-black text-opacity-60 whitespace-pre-line">
              Tem certeza de que deseja realizar o bloqueio temporário do seu cartão com
              final <strong>{{ cards.list[selectedCard].last_4_digits }}</strong>?
              Ao confirmar esta ação, seu cartão ficará temporariamente impossibilitado de realizar qualquer tipo de transação.
              Para realizar o desbloqueio, basta acessar o internet banking ou aplicativo e
              clicar na opção de desbloqueio.
            </p>
          </div>
          <div
            v-else-if="
              cards.list[selectedCard].status === 'locked' &&
              changeStatusForm.status !== 'thief_or_loss'
            "
          >
            <div class="flex items justify-center mb-4">
              <img
                alt="Logo"
                class="mt-2 mr-4"
                src="images/unlockCard.png"
                width="200"
              />
            </div>
             <p class="text-base text-black text-opacity-60 whitespace-pre-line">
              Tem certeza de que deseja realizar o desbloquei do seu cartão com final <strong>{{ cards.list[selectedCard].last_4_digits }}</strong>?
              Ao confirmar esta ação, o seu cartão ficará disponível para realizar qualquer tipo
                de transação.
              Para realizar o bloqueio novamente, basta acessar o internet banking ou aplicativo
            e clicar na opção de bloquear.
            </p>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="flex justify-between">
          <button-cancel @click.native="changeStatusModal = false">
            Cancelar
          </button-cancel>

          <button-confirmation
            class="ml-2"
            :class="{ 'opacity-25': changeStatusForm.processing }"
            :disabled="changeStatusForm.processing"
            @click.native="openChangeVerify"
          >
            Prosseguir
          </button-confirmation>
        </div>
      </template>
    </jet-confirmation-modal>

    <!-- MODAL DE SOLICITAR REPORT POR PERDA E ROUBO -->
    <jet-confirmation-modal
      v-if="changeReportModal"
      :show="changeReportModal"
      @close="changeReportModal = false"
      :scroll="false"
      :noBgFooter="true"
    >
      <template #title>
          <span class="text-black text-opacity-70 font-bold text-xl">
            Deseja mesmo reportar a perda ou roubo do cartão?
          </span>
        <jet-section-border />
      </template>

      <template #content>
        <div class="flex flex-col">
          <div>
            <div class="flex items justify-center mb-4">
              <img
                alt="Logo"
                class="mt-2 mr-4"
                src="images/reportCard.svg"
                width="200"
              />
            </div>
              <p class="text-base text-black text-opacity-60 whitespace-normal">
               Tem certeza que deseja reportar a perda ou roubo do seu cartão com
              final <strong>{{ cards.list[selectedCard].last_4_digits }}</strong>?
              Ao confirmar a perda ou roubo do cartão o mesmo será bloqueado permanentemente
              e será possível realizar a solicitação de um novo
              cartão pelo internet banking ou aplicativo.
            </p>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="flex justify-between">
          <button-cancel @click.native="changeReportModal = false">
            Cancelar
          </button-cancel>

          <button-confirmation
            class="ml-2"
            :class="{ 'opacity-25': changeStatusForm.processing }"
            :disabled="changeStatusForm.processing"
            @click.native="openChangeVerify"
          >
            Prosseguir
          </button-confirmation>
        </div>
      </template>
    </jet-confirmation-modal>

    <!-- MODAL DE AUTORIZAÇÃO DE ALTERAÇÃO DE STATUS -->
    <jet-confirmation-modal
      v-if="modalauthorizedStatus"
      :show="modalauthorizedStatus"
      @close="modalauthorizedStatus = false"
      :scroll="false"
      :max-width="'xl'"
      :noBgFooter="true"
    >
      <template #title>
        <div
          v-if="!['cancel', 'report_theft_or_loss'].includes(changeStatusForm.status)"
          class="text-black text-opacity-70 font-bold text-xl py-2"
        >
          Confirme o {{cards.list[selectedCard].status === 'locked' ? 'desbloqueio' : 'bloqueio'}}
          do cartão
        </div>
        <div v-else-if="changeStatusForm.status === 'report_theft_or_loss'" class="text-black text-opacity-70 font-bold text-xl py-2">
          Confirme o reporte de roubo ou perda do cartão
        </div>
        <div v-else class="text-black text-opacity-70 font-bold text-xl py-2">
          Confirme o cancelamento do cartão
        </div>
        <hr class="my-2" />
      </template>

      <template #content>
        <div class="flex flex-col space-y-4">
          <div class="text-base text-black text-opacity-60 mt-4">
            Autorize a solicitação através do seu código 2FA.
          </div>
          <div>
            <jet-label for="google_code" value="Código de 2FA" />
            <jet-input
              id="google_code"
              type="text"
              :placeholder="'Ex: 102330'"
              class="mt-1 block w-full"
              v-model="changeStatusForm.google_code"
            />
            <jet-input-error
              :message="changeStatusForm.error('google_code')"
              class="mt-2"
            />
          </div>
        </div>
      </template>

      <template #footer>
        <div class="flex items-center justify-between">
          <button-cancel @click.native="modalauthorizedStatus = false">
            Cancelar
          </button-cancel>

          <button-confirmation
            class="ml-2"
            :class="{ 'opacity-25': changeStatusForm.processing }"
            :disabled="changeStatusForm.processing"
            @click.native="changeStatus"
          >
            Confirmar
          </button-confirmation>
        </div>
      </template>
    </jet-confirmation-modal>

    <!-- MODAL AUTORIZAÇÃO NOVO CARTÃO VIRTUAL -->
    <jet-confirmation-modal
      v-if="modalRequestCardVirtual"
      :show="modalRequestCardVirtual"
      @close="modalRequestCardVirtual = false"
      :scroll="false"
      :max-width="'xl'"
      :noBgFooter="true"
    >
      <template #title>
        <span class="text-black text-opacity-70 font-bold text-xl py-2 mt-4">
          Confirme a solicitação com o código 2FA
        </span>
        <hr class="my-2" />
      </template>

      <template #content>
        <div class="flex flex-col space-y-4">
          <div class="text-base text-black text-opacity-60">
            Autorize a solicitação através do seu código 2FA.
          </div>
          <div>
            <jet-label for="google_code" value="Código de Autorização" />
            <jet-input
              id="google_code"
              type="text"
              class="mt-1 block w-full"
              v-model="form.google_code"
            />
            <jet-input-error
              :message="form.error('google_code')"
              class="mt-2"
            />
          </div>
        </div>
      </template>

      <template #footer>
        <div class="flex items-center justify-between">
          <button-cancel @click.native="modalRequestCardVirtual = false">
            Cancelar
          </button-cancel>
          <button-confirmation
            class="ml-2"
            :class="{ 'opacity-25': form.processing }"
            :disabled="form.processing"
            @click.native="requestVirtualCard"
          >
            Confirmar
          </button-confirmation>
        </div>
      </template>
    </jet-confirmation-modal>

    <!-- MODAL DE AUTORIZAÇÃO DE NOVO CARTÃO FÍSICO -->
    <jet-confirmation-modal
      :show="Modalauthorized"
      @close="Modalauthorized = false"
      :scroll="false"
      :max-width="'xl'"
      :noBgFooter="true"
    >
      <template #title>
        <span class="text-black text-opacity-70 font-bold text-xl py-2 mt-4">
          Confirme a solicitação com o código 2FA
        </span>
        <hr class="my-2" />
      </template>

      <template #content>
        <div class="flex flex-col space-y-4">
          <div class="text-base text-black text-opacity-60">
            Autorize a solicitação através do seu código 2FA.
          </div>
          <div>
            <jet-label class="mb-3" for="google_code" value="Código de 2FA" />
            <jet-input
              id="google_code"
              type="text"
              :placeholder="'Ex: 102330'"
              class="mt-1 block w-full"
              v-model="form.google_code"
            />
            <jet-input-error
              :message="form.error('google_code')"
              class="mt-2"
            />
          </div>
        </div>
      </template>

      <template #footer>
        <div class="flex items-center justify-between">
          <button-cancel @click.native="Modalauthorized = false">
            Cancelar
          </button-cancel>

          <button-confirmation
            class="ml-2"
            :class="{ 'opacity-25': form.processing }"
            :disabled="form.processing"
            @click.native="cardsRequest"
          >
            Confirmar
          </button-confirmation>
        </div>
      </template>
    </jet-confirmation-modal>

    <!-- MODAL AUTORIZAÇÃO PARA EXCLUIR CARTÃO VIRTUAL -->
    <jet-confirmation-modal
      v-if="authorizationRemoveCard"
      :show="authorizationRemoveCard"
      @close="authorizationRemoveCard = false"
      :scroll="false"
      :max-width="'xl'"
      :noBgFooter="true"
    >
      <template #title>
        <div class="text-black text-opacity-70 font-bold text-xl py-2">
          Confirme a remoção do cartão virtual
        </div>
        <hr class="my-2" />
      </template>

      <template #content>
        <div class="flex flex-col space-y-4">
          <div class="text-base text-black text-opacity-60 mt-4">
            Autorize a solicitação através do seu código 2FA.
          </div>
          <div>
            <jet-label for="google_code" value="Código de Autorização" />
            <jet-input
              id="google_code"
              type="text"
              class="mt-1 block w-full"
              v-model="formDeleteCard.google_code"
            />
            <jet-input-error
              :message="formDeleteCard.error('google_code')"
              class="mt-2"
            />
          </div>
        </div>
      </template>

      <template #footer>
        <div class="flex items-center justify-between">
          <button-cancel @click.native="authorizationRemoveCard = false">
            Cancelar
          </button-cancel>

          <button-confirmation
            class="ml-2"
            :class="{ 'opacity-25': formDeleteCard.processing }"
            :disabled="formDeleteCard.processing"
            @click.native="removeCardVirtual"
          >
            Confirmar
          </button-confirmation>
        </div>
      </template>
    </jet-confirmation-modal>
  </app-layout>
</template>
<script>
import AppLayout from "./../../Layouts/AppLayout";
import Welcome from "./../../Jetstream/Welcome";
import JetConfirmationModal from "./../../Jetstream/ConfirmationModal";
import ApplicationMark from "./../../Jetstream/ApplicationMark";
import JetDialogModal from "./../../Jetstream/DialogModal";
import Flash from "../../Helpers/Flash";
import InertiaTable from "../../Helpers/Tables/InertiaTable";
import Balance from "../../Helpers/Balance";
import Button from "../../Jetstream/Button";
import JetLabel from "../../Jetstream/Label";
import JetInput from "../../Jetstream/Input";
import JetInputError from "../../Jetstream/InputError";
import JetSectionBorder from "../../Jetstream/SectionBorder";
import ButtonConfirmation from "../../Jetstream/ButtonConfirmation.vue";
import ButtonCancel from "../../Jetstream/ButtonCancel.vue";
import DateFilter from "../../Helpers/Tables/DateFilter.vue";
import CardsCarrosel from "./components/CardsCarrosel.vue";
import ModalPassword from "./components/ModalPassword.vue";

export default {
  components: {
    Button,
    Balance,
    AppLayout,
    Flash,
    InertiaTable,
    Welcome,
    JetConfirmationModal,
    JetDialogModal,
    ApplicationMark,
    JetLabel,
    JetInput,
    JetInputError,
    JetSectionBorder,
    ButtonConfirmation,
    ButtonCancel,
    DateFilter,
    CardsCarrosel,
    ModalPassword,
  },
  props: [
    "account",
    "cards",
    "virtual_cards",
    "errors",
    "transactions",
    "customer",
  ],
  data() {
    return {
      buttonsDateFilter: [
        {
          name: "Hoje",
          key: "today",
        },
        {
          name: "Ontem",
          key: "yesterday",
        },
        {
          name: "Esta semana",
          key: "7_days",
        },
        {
          name: "Este mês",
          key: "this_month",
        },
      ],
      modalauthorizedStatus: false,
      modalPassword: false,
      modalRequestCardVirtual: false,
      Modalauthorized: false,
      selectedCard: 0,
      confirmRequestVirtualCard: false,
      changeStatusModal: false,
      changeReportModal: false,
      cardDelete: null,
      authorizationRemoveCard: false,

      virtualCardModal: false,
      form: this.$inertia.form({
        google_code: null,
        uuid: null,
      }),
      formDeleteCard: this.$inertia.form({
        _method: "POST",
        google_code: null,
        reference_card_uuid: null,
        last_4_digits: null,
        is_virtual: false,
      }),
      changeStatusForm: this.$inertia.form(
        {
          _method: "POST",
          uuid: null,
          status: null,
          type: null,
          last_digits: null,
          google_code: null,
        },
        {
          resetOnSuccess: false,
        }
      ),
      activeCard: {
        is_virtual: false,
        is_active: false,
        uuid: null,
        status: null,
        request_status: null,
        card_number: null,
        expiration_date: "----",
        embossing_name: null,
        last_4_digits: null,
      },
      columns: [
        {
          text: "Data",
          className: "text-left text-gray-500",
          key: "datePuchase",
          sortable: false,
        },
        {
          text: "Descrição",
          className: "text-left text-gray-500",
          key: "description",
          sortable: false,
        },
        {
          text: "Origem",
          className: "text-left text-gray-500",
          key: "origin",
          sortable: true,
        },
        {
          text: "Valor",
          className: "text-left text-gray-500",
          key: "valuePurchase",
          sortable: true,
        },
        {
          text: "Saldo",
          className: "text-left text-gray-500",
          key: "balance",
          sortable: false,
        },
      ],
      params: {
        sort: "request_date:desc",
        page: 1,
        ...this.$page.props.queryString,
      },
      filters: [{}],
    };
  },
  created() {
    const { uuid } = this.$page.props.queryString;
    const indexCard = this.cards?.list?.findIndex(
      (card) => card.uuid && card.uuid === uuid
    );
    this.selectedCard = indexCard === -1 ? 0 : indexCard;
    this.activeCard = this.cards?.list[this.selectedCard] ?? {};
  },
  computed: {
    verifyStatus() {
      const { status } = this.cards.list[this.selectedCard];
      if (status === "active") {
        return { bg: "", isClick: true };
      } else {
        return { bg: "opacity-50 cursor-not-allowed", isClick: false };
      }
    },
   verifyVirtualActive() {
    const cardFisico = !this.account.prepaid_cards.some(item => item.status === 'active' || item.status === 'locked');
    const hasActiveOrBlock = (status) => status === 'active' || status === 'locked';
    const hasVirtualValid = (this.account.virtual_card ?? []).some(item => hasActiveOrBlock(item.status));

    if (cardFisico || hasVirtualValid) {
        return { bg: "opacity-50 cursor-not-allowed", isClick: false };
    } else {
        return { bg: "", isClick: true };
    }
  },
    verifyRequestCard() {
        const hasCardRequest = (this.account.prepaid_card ?? []).every(item => item.status !== 'theft_or_loss')
        if(!hasCardRequest) return  {bg: "", isClick: true }
        return  { bg: "opacity-50 cursor-not-allowed", isClick: false };
    },
    titleModalRequests() {
      if (this.cards.list[this.selectedCard].status === "locked")
        return "Desbloquear cartão";
      return "Deseja bloquear o cartão?";
    },
  },
  mounted() {
    this.activeCard = this.cards.list[0] || {
      is_virtual: false,
      is_active: false,
      uuid: null,
      status: null,
      request_status: null,
      card_number: null,
      expiration_date: "----",
      embossing_name: null,
      last_4_digits: null,
    };
  },
  beforeUpdate() {
    this.activeCard = this.cards.list[0] || {
      is_virtual: false,
      is_active: false,
      uuid: null,
      status: null,
      request_status: null,
      card_number: null,
      expiration_date: "----",
      embossing_name: null,
      last_4_digits: null,
    };
  },
  methods: {
    showReuqests() {
      return this.$inertia.get(route("card.requests-list"));
    },
    openChangeStatusModal(status, item) {
      this.changeStatusForm.status = status;
      this.changeStatusForm.uuid = item.uuid ?? item.reference_card_uuid
      if (status === "report_theft_or_loss") {
        return (this.changeReportModal = true);
      }
      this.changeStatusForm.type = item.is_virtual ? 'virtual' : 'prepaid';
      this.changeStatusForm.last_digits = item.last_4_digits;
      return (this.changeStatusModal = true);
    },
    openChangeCancel(status, item) {
     this.changeStatusForm.uuid = item.uuid
     this.changeStatusForm.status = status;
     this.modalauthorizedStatus = true;
    },
    openChangeVerify() {
      this.changeStatusModal = false;
      this.changeReportModal = false;
      this.modalauthorizedStatus = true;
    },
    changeStatus() {
      this.changeStatusForm.post(this.route("card.change-status"), {
        preserveScroll: true,
        onError: () => {
          this.changeStatusForm.processing = false;
          this.changeStatusForm.reset()
        },
        onSuccess: () => {
          this.changeStatusForm.processing = false;
          this.modalauthorizedStatus = false
          this.changeStatusForm.reset()
        },
      });
    },
    openRemoveCardModal(item) {
      this.formDeleteCard.reference_card_uuid = item.reference_card_uuid;
      this.formDeleteCard.last_4_digits = item.last_4_digits;
      this.formDeleteCard.is_virtual = item.is_virtual;
      this.authorizationRemoveCard = true;
    },
    removeCardVirtual() {
      this.formDeleteCard.post(this.route("card.send-cancel"), {
        preserveState: false,
        onError: () => {
          this.formDeleteCard.processing = false;
          this.formDeleteCard.reset();
        },
        onSuccess: () => {
          this.formDeleteCard.processing = false;
          this.formDeleteCard.reset();
        },
      });
    },
    showModalCardVirtual(uuid) {
      this.modalRequestCardVirtual = true;
      this.form.uuid = uuid;
    },
    requestVirtualCard() {
      this.form.post(this.route("card.virtual-card-request"), {
        preserveScroll: true,
        onError: () => {
          this.form.processing = false;
          this.form.reset();
        },
        onSuccess: () => {
          this.form.processing = false;
          this.modalRequestCardVirtual = false;
          this.form.reset();
        },
      });
    },
    showModalRequestCard() {
      this.Modalauthorized = true;
    },
    cardsRequest() {
      this.form.post(this.route("card.request"), {
        preserveScroll: true,
        onError: () => {
          this.form.processing = false;
          this.form.reset();
        },
        onSuccess: () => {
          this.form.processing = false;
          this.form.reset();
        },
      });
    },
  },
};
</script>
